/**
 * TanStack Query hooks for the /auth-api/* contract.
 *
 * All queries are read-only and cacheable; the login mutation always
 * runs fresh. Query keys are namespaced under ['auth'] so apps can
 * invalidate the whole auth domain with one call.
 */
import { useMutation } from '@tanstack/react-query';
import { postLogin } from './api';
export const authQueryKeys = {
    all: ['auth'],
};
export function useLogin() {
    return useMutation({
        mutationKey: [...authQueryKeys.all, 'login'],
        mutationFn: postLogin,
    });
}
//# sourceMappingURL=queries.js.map